import CloseIcon from "@mui/icons-material/Close";
import { Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import { LabelCompo } from "../../components/Comman/Label";
import { redColor, titleColor } from "../../config/ColorObj";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import dayjs from "dayjs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const TimeSlotPopUpRMDashboard = ({ selectedDate, rowLink, timeSlotList, handleCloses, open, columns, rows }) => {

    const handleClose = () => {
        handleCloses();
    };



    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="lg"
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Time Slot
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <DynamicDetails
                        DataToSet={
                            [{
                                xs: 12,
                                sm: 4,
                                md: 4,
                                lg: 4,
                                label: "Time Slot",
                                value: timeSlotList[0].fromTime + " To " + timeSlotList[0].toTime,
                            },
                            {
                                xs: 12,
                                sm: 4,
                                md: 4,
                                lg: 4,
                                label: "Selected Date",
                                value: dayjs(selectedDate).format("DD-MM-YYYY"),
                            },]}
                    />

                    <DynamicTable
                        data={rows}
                        tableHead={columns}
                        showPegination={false}
                        isActionColActive={false}
                        rowLink={rowLink}
                    />
                    <br />
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TimeSlotPopUpRMDashboard);
